/**
 * Custom Bulk order form development for Cheapest Clothing USA.
 * All right reserved by Cheapest Clothing USA © 2025.
 * Developed by Senior Shopify Designer & Developer Arafat Jahan https://arafatjahan.com
 * Version 1.1 revised 0.3
 */

;(() => {
  // Get config from liquid
  var config = window.bulkOrderConfig || {}
  var t = config.translations || {}
  
  // Inventory API endpoint for real-time location quantities
  var INVENTORY_API_URL = "https://api.cheapestclothing.com/inventory.php"
  
  // Variant cache settings (1 hour cache for color/size data)
  var VARIANT_CACHE_PREFIX = "cc_bulk_variants_"
  var VARIANT_CACHE_DURATION = 60 * 60 * 1000 // 1 hour in milliseconds
  
  // Inventory cache settings (5 minutes cache - balance between freshness and performance)
  var INVENTORY_CACHE_PREFIX = "cc_inventory_"
  var INVENTORY_CACHE_DURATION = 5 * 60 * 1000 // 5 minutes in milliseconds
  
  // Generic cache helpers
  function getCache(prefix, key, duration) {
    try {
      var cached = localStorage.getItem(prefix + key)
      if (cached) {
        var parsed = JSON.parse(cached)
        var age = Date.now() - parsed.timestamp
        if (age < duration) {
          return parsed.data
        }
        localStorage.removeItem(prefix + key)
      }
    } catch (e) {}
    return null
  }
  
  function setCache(prefix, key, data) {
    // Clean old cache first to make space
    cleanOldCache()
    
    try {
      var cacheData = JSON.stringify({
        data: data,
        timestamp: Date.now()
      })
      localStorage.setItem(prefix + key, cacheData)
    } catch (e) {
      // Clear ALL our cache and retry once
      clearAllCCCache()
      try {
        localStorage.setItem(prefix + key, cacheData)
      } catch (e2) {}
    }
  }
  
  function clearAllCCCache() {
    try {
      var prefixes = [VARIANT_CACHE_PREFIX, INVENTORY_CACHE_PREFIX, "cc_swatch_", "cc_variant_picker_"]
      var keysToRemove = []
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i)
        if (key) {
          for (var p = 0; p < prefixes.length; p++) {
            if (key.startsWith(prefixes[p])) {
              keysToRemove.push(key)
              break
            }
          }
        }
      }
      keysToRemove.forEach(function(k) { localStorage.removeItem(k) })
    } catch (e) {}
  }
  
  function cleanOldCache() {
    try {
      var prefixes = [VARIANT_CACHE_PREFIX, INVENTORY_CACHE_PREFIX, "cc_swatch_", "cc_variant_picker_"]
      var keysToRemove = []
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i)
        if (key) {
          for (var p = 0; p < prefixes.length; p++) {
            if (key.startsWith(prefixes[p])) {
              try {
                var item = JSON.parse(localStorage.getItem(key))
                // Remove if older than 10 minutes (more aggressive cleanup)
                if (Date.now() - item.timestamp > 10 * 60 * 1000) {
                  keysToRemove.push(key)
                }
              } catch (e) {
                keysToRemove.push(key)
              }
              break
            }
          }
        }
      }
      keysToRemove.forEach(function(k) { localStorage.removeItem(k) })
    } catch (e) {}
  }
  
  // Variant cache helpers
  function getCachedVariants(key) {
    return getCache(VARIANT_CACHE_PREFIX, key, VARIANT_CACHE_DURATION)
  }
  
  function setCachedVariants(key, data) {
    setCache(VARIANT_CACHE_PREFIX, key, data)
  }
  
  // Inventory cache helpers
  function getCachedInventory(key) {
    return getCache(INVENTORY_CACHE_PREFIX, key, INVENTORY_CACHE_DURATION)
  }
  
  function setCachedInventory(key, data) {
    setCache(INVENTORY_CACHE_PREFIX, key, data)
  }

  // Helper functions
  function imposeMinMax(el) {
    if (el.value !== "") {
      if (Number.parseInt(el.value) < Number.parseInt(el.min)) {
        el.value = el.min
      }
      if (Number.parseInt(el.value) > Number.parseInt(el.max)) {
        el.value = el.max
      }
    }
  }

  // Expose to global scope for inline onchange
  window.imposeMinMax = imposeMinMax

  function normalizeColor(color) {
    return color.replace(/\s+/g, "").replace(/'/g, "").replace(/\//g, "").replace(/\(/g, "").replace(/\)/g, "")
  }

  function normalizeDotColor(color) {
    return color.replace(/\s+/g, "").replace(/'/g, "").replace(/\//g, "").replace(/\./g, "").replace(/\(/g, "").replace(/\)/g, "")
  }

  function blinkCursor() {
    var searchInput = document.getElementById("dropdownSearch")
    if (searchInput) searchInput.focus()
  }

  function filterDropdown() {
    var input = document.getElementById("dropdownSearch")
    var filter = input.value.toUpperCase()
    var options = document.getElementsByClassName("SelectOptions")
    for (var i = 0; i < options.length; i++) {
      var colorName = options[i].textContent.toUpperCase()
      options[i].style.display = colorName.indexOf(filter) > -1 ? "" : "none"
    }
  }

  function formatMoney(amount, currency) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(amount)
  }

  var selectedColor = ""

  // Progress bar update helper
  function updateLoadingProgress(percent, text) {
    var container = document.getElementById("bulk-order-api-container")
    if (!container) return
    var fill = container.querySelector(".loading-progress-fill")
    var percentText = container.querySelector(".loading-progress-percent")
    var statusText = container.querySelector(".loading-progress-text")
    if (fill) fill.style.width = percent + "%"
    if (percentText) percentText.textContent = percent + "%"
    if (statusText && text) statusText.textContent = text
  }

  // Mode B: API-based rendering
  function initModeBAPI() {
    var apiContainer = document.getElementById("bulk-order-api-container")
    if (!apiContainer) return
    
    // Start progress
    updateLoadingProgress(5, "Initializing...")

    var token = apiContainer.getAttribute("data-token")
    var productId = apiContainer.getAttribute("data-product-id")
    var lowStockQty = Number.parseInt(apiContainer.getAttribute("data-low-stock")) || 11

    if (!token || token.trim() === "") {
      apiContainer.querySelector(".bulk-api-loading").style.display = "none"
      apiContainer.querySelector(".bulk-api-error").style.display = "block"
      apiContainer.querySelector(".bulk-api-error").textContent =
        "Storefront API token is missing. Please add your Storefront API token to the snippet."
      return
    }

    var allVariants = []
    var cursor = null
    
    // Get current language from HTML lang attribute or URL path
    var currentLang = document.documentElement.lang || 'en'
    // Convert to Shopify language code format (e.g., 'es' -> 'ES', 'en' -> 'EN')
    var shopifyLangCode = currentLang.split('-')[0].toUpperCase()
    
    // Cache key includes language to avoid returning wrong language data
    var cacheKey = productId + '_' + shopifyLangCode

    // Check cache for variant color/size data (1 hour cache)
    var cachedVariants = getCachedVariants(cacheKey)
    if (cachedVariants) {
      updateLoadingProgress(40, "Loading from cache...")
      // Cache hit - skip variant fetch, go straight to inventory
      fetchRealTimeInventory(cachedVariants, lowStockQty)
      return
    }

    var variantFetchCount = 0
    
    function fetchVariants() {
      updateLoadingProgress(10 + Math.min(variantFetchCount * 10, 30), "Loading product variants...")
      variantFetchCount++
      
      // Query only fetches color_code and colorswatch metafields
      // Warehouse inventory is fetched separately via real-time API
      var query =
        '\n        query getProductVariants($productId: ID!, $cursor: String, $language: LanguageCode) @inContext(language: $language) {\n          product(id: $productId) {\n            variants(first: 250, after: $cursor) {\n              pageInfo {\n                hasNextPage\n                endCursor\n              }\n              edges {\n                node {\n                  id\n                  title\n                  price {\n                    amount\n                    currencyCode\n                  }\n                  selectedOptions {\n                    name\n                    value\n                  }\n                  metafields(identifiers: [\n                    {namespace: "custom", key: "color_code"},\n                    {namespace: "custom", key: "colorswatch"}\n                  ]) {\n                    key\n                    value\n                  }\n                }\n              }\n            }\n          }\n        }\n      '

      fetch("/api/2024-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token,
        },
        body: JSON.stringify({
          query: query,
          variables: {
            productId: "gid://shopify/Product/" + productId,
            cursor: cursor,
            language: shopifyLangCode,
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.errors) {
            apiContainer.querySelector(".bulk-api-loading").style.display = "none"
            apiContainer.querySelector(".bulk-api-error").style.display = "block"
            apiContainer.querySelector(".bulk-api-error").textContent = "API Error: " + data.errors[0].message
            return
          }
          console.log(data.data);

          if (!data.data || !data.data.product) {
            apiContainer.querySelector(".bulk-api-loading").style.display = "none"
            apiContainer.querySelector(".bulk-api-error").style.display = "block"
            apiContainer.querySelector(".bulk-api-error").textContent =
              "Product not found. Please check if the product is published to the Storefront API sales channel."
            return
          }

          var variants = data.data.product.variants
          variants.edges.forEach((edge) => {
            var v = edge.node
            var variantData = {
              id: v.id.replace("gid://shopify/ProductVariant/", ""),
              gid: v.id,
              title: v.title,
              price: v.price.amount,
              currencyCode: v.price.currencyCode,
              option1: "",
              option2: "",
              metafields: {},
            }

            v.selectedOptions.forEach((opt, idx) => {
              if (idx === 0) variantData.option1 = opt.value
              if (idx === 1) variantData.option2 = opt.value
            })

            v.metafields.forEach((mf) => {
              if (mf && mf.key) {
                variantData.metafields[mf.key] = mf.value ? Number.parseInt(mf.value) || mf.value : 0
              }
            })

            allVariants.push(variantData)
          })

          if (variants.pageInfo.hasNextPage) {
            cursor = variants.pageInfo.endCursor
            fetchVariants()
          } else {
            // Save to cache (color/size data - 1 hour cache)
            setCachedVariants(cacheKey, allVariants)
            // Fetch real-time inventory from API
            fetchRealTimeInventory(allVariants, lowStockQty)
          }
        })
        .catch((error) => {
          var loadingEl = apiContainer.querySelector(".bulk-api-loading")
          var errorEl = apiContainer.querySelector(".bulk-api-error")
          if (loadingEl) loadingEl.style.display = "none"
          if (errorEl) {
            errorEl.style.display = "block"
            errorEl.textContent = "Network error: " + error.message
          }
        })
    }

    // Fetch real-time inventory from our API and merge with variant data
    function fetchRealTimeInventory(variants, lowStockQty) {
      updateLoadingProgress(50, "Loading warehouse inventory...")
      
      // Warehouse code to metafield key mapping
      var codeToKey = {
        'CN': 'fresno_ca',
        'NV': 'reno_nv',
        'TX': 'fort_worth_tx',
        'KS': 'olathe_ks',
        'OH': 'west_chester_township_oh',
        'GA': 'mcdonough_ga',
        'IL': 'lockport_il',
        'FO': 'orlando_fl',
        'MA': 'middleborough_ma',
        'PA': 'reading_pa'
      }
      
      // Check inventory cache first (5 minute cache)
      var inventoryCacheKey = productId
      var cachedInventory = getCachedInventory(inventoryCacheKey)
      if (cachedInventory) {
        updateLoadingProgress(90, "Loading from cache...")
        // Apply cached inventory to variants
        variants.forEach(function(v) {
          var inv = cachedInventory[v.id]
          if (inv && inv.inventory) {
            for (var code in inv.inventory) {
              var key = codeToKey[code]
              if (key) {
                v.metafields[key] = inv.inventory[code]
              }
            }
          }
        })
        renderBulkForm(variants, lowStockQty)
        return
      }
      
      var variantIds = variants.map(function(v) { return v.id }).join(",")
      
      // Split into chunks of 100 to avoid URL length limits
      var chunkSize = 100
      var chunks = []
      for (var i = 0; i < variants.length; i += chunkSize) {
        chunks.push(variants.slice(i, i + chunkSize))
      }
      
      var inventoryData = {}
      var completedChunks = 0
      var totalChunks = chunks.length
      
      function processChunk(chunkIndex) {
        var chunk = chunks[chunkIndex]
        var ids = chunk.map(function(v) { return v.id }).join(",")
        
        // Update progress: 50-90% for inventory loading
        var chunkProgress = 50 + Math.floor((chunkIndex / totalChunks) * 40)
        updateLoadingProgress(chunkProgress, "Loading warehouse inventory... (" + (chunkIndex + 1) + "/" + totalChunks + ")")
        
        fetch(INVENTORY_API_URL + "?variants=" + ids)
          .then(function(response) { return response.json() })
          .then(function(data) {
            // Merge inventory data - only store inventory object (not sku) to reduce size
            for (var variantId in data) {
              inventoryData[variantId] = { inventory: data[variantId].inventory || {} }
            }
            
            completedChunks++
            
            // Update progress after each chunk completes
            var completedProgress = 50 + Math.floor((completedChunks / totalChunks) * 40)
            updateLoadingProgress(completedProgress, "Loading warehouse inventory... (" + completedChunks + "/" + totalChunks + ")")
            
            if (completedChunks === chunks.length) {
              updateLoadingProgress(95, "Preparing form...")
              
              // Save inventory to cache (2 minute cache)
              setCachedInventory(inventoryCacheKey, inventoryData)
              
              // All chunks fetched, merge inventory into variants
              variants.forEach(function(v) {
                var inv = inventoryData[v.id]
                if (inv && inv.inventory) {
                  // Map API response codes to metafield keys
                  for (var code in inv.inventory) {
                    var key = codeToKey[code]
                    if (key) {
                      v.metafields[key] = inv.inventory[code]
                    }
                  }
                }
              })
              
              renderBulkForm(variants, lowStockQty)
            } else if (chunkIndex + 1 < chunks.length) {
              // Fetch next chunk
              processChunk(chunkIndex + 1)
            }
          })
          .catch(function(error) {
            // Silent fail - proceed with empty inventory (will show out of stock)
            // On error, proceed with empty inventory (will show out of stock)
            completedChunks++
            if (completedChunks === chunks.length) {
              renderBulkForm(variants, lowStockQty)
            } else if (chunkIndex + 1 < chunks.length) {
              processChunk(chunkIndex + 1)
            }
          })
      }
      
      if (chunks.length > 0) {
        processChunk(0)
      } else {
        renderBulkForm(variants, lowStockQty)
      }
    }

    function renderBulkForm(variants, lowStockQty) {
      updateLoadingProgress(100, "Complete!")
      
      var colorList = []
      var colorMap = {}

      variants.forEach((v) => {
        if (!colorMap[v.option1]) {
          colorMap[v.option1] = []
          colorList.push(v.option1)
        }
        colorMap[v.option1].push(v)
      })

      var whiteColors = []
      var blackColors = []
      var otherColors = []

      colorList.forEach((c) => {
        if (c === "White" || c === "Blanc") whiteColors.push(c)
        else if (c === "Black" || c === "Noir") blackColors.push(c)
        else otherColors.push(c)
      })

      var sortedColors = whiteColors.concat(blackColors).concat(otherColors)

      var warehouses = [
        { key: "fresno_ca", name: "Fresno, CA", code: "CN" },
        { key: "reno_nv", name: "Reno, NV", code: "NV" },
        { key: "fort_worth_tx", name: "Fort Worth, TX", code: "TX" },
        { key: "olathe_ks", name: "Olathe, KS", code: "KS" },
        { key: "west_chester_township_oh", name: "West Chester, OH", code: "OH" },
        { key: "mcdonough_ga", name: "McDonough, GA", code: "GA" },
        { key: "lockport_il", name: "Lockport, IL", code: "IL" },
        { key: "orlando_fl", name: "Orlando, FL", code: "FO" },
        { key: "middleborough_ma", name: "Middleboro, MA", code: "MA" },
        { key: "reading_pa", name: "Reading, PA", code: "PA" },
      ]

      var html = ""
      html += '<div class="bulk_form_notice">' + t.bulkFormNotice + "</div>"
      html += '<div class="form-header-actions">'
      html += '<div id="colorDropdown" class="dropdown-container">'
      html += '<div class="dropdown-header FirstSelectColorOption" value="">' + t.selectColor + "</div>"
      html += '<div class="dropdownContentContainer">'
      html += '<div class="dropdownSearchContainer"><input type="text" id="dropdownSearch" autofocus></div>'
      html += '<div class="ColorOptionsContent">'

      sortedColors.forEach((color) => {
        var firstVariant = colorMap[color][0]
        var colorCode = firstVariant.metafields.color_code || ""
        var swatchImg = firstVariant.metafields.colorswatch || ""
        var normalizedColor = color.replace(/\s+/g, "").replace(/'/g, "").replace(/\//g, "").replace(/\(/g, "").replace(/\)/g, "")
        html += '<div class="SelectOptions dropdown-hide" value="' + normalizedColor + '" data-original-color="' + color + '">'
        html +=
          '<span class="color-circle" style="background-color: ' +
          colorCode +
          "; background-image: url('" +
          swatchImg +
          "')\"></span>" +
          color
        html += "</div>"
      })

      html += "</div></div></div>"
      html += '<div class="right_side_button">'
      html += '<div class="button--secondary" id="toggleView">' + t.viewAllColors + "</div>"
      html +=
        '<div type="button" class="add-to-cart-bulk button--primary" id="add-to-cart-bulk-secondary" onclick="document.getElementById(\'add-to-cart-bulk\').click()">' +
        t.addToCart +
        "</div>"
      html += "</div></div>"

      html += '<form action="/cart/add" method="post" id="bulk-order-form">'
      html += '<div class="start-main-color-list">'

      sortedColors.forEach((color, colorIndex) => {
        var colorVariants = colorMap[color]
        var firstVariant = colorVariants[0]
        var colorCode = firstVariant.metafields.color_code || ""
        var swatchImg = firstVariant.metafields.colorswatch || ""
        var normalizedColor = color.replace(/\s+/g, "").replace(/'/g, "").replace(/\//g, "").replace(/\./g, "").replace(/\(/g, "").replace(/\)/g, "")
        var downcasedColor = color.toLowerCase()
        var orderValue =
          downcasedColor === "white" || downcasedColor === "blanc"
            ? "001"
            : downcasedColor === "black" || downcasedColor === "noir"
              ? "002"
              : String(Math.round(firstVariant.price * 100))

        html += '<div class="Color_warehouse_master_block ' + normalizedColor + '" style="order: ' + orderValue + '">'
        html += '<div class="color_name">'
        html +=
          '<span class="color_round' +
          (downcasedColor === "white" || downcasedColor === "blanc" ? " color_round_white" : "") +
          '" style="background-color: ' +
          colorCode +
          "; background-image: url('" +
          swatchImg +
          "')\"></span>"
        html += "<span>" + color + '</span><span id="swipeRightButton" class="SwipeRight">Right →</span>'
        html += "</div>"

        var hasStock = colorVariants.some((v) => warehouses.some((w) => (v.metafields[w.key] || 0) > 0))

        if (hasStock) {
          // Size/Price header row
          html += '<div class="each_warehouse_block">'
          html +=
            '<span class="warehouse_name">' + t.size + ' <br> <span class="warehouse_cat">' + t.price + "</span></span>"
          html += '<ul class="warehouse_ul">'
          colorVariants.forEach((v) => {
            html += '<li class="ai_store">'
            html += '<span class="size_block">' + v.option2 + "</span>"
            html +=
              '<div class="desc-wrapper"><span class="price_small">' +
              formatMoney(v.price, v.currencyCode) +
              "</span></div>"
            html += "</li>"
          })
          html += "</ul></div>"

          // Warehouse rows
          warehouses.forEach((w) => {
            var warehouseHasStock = colorVariants.some((v) => (v.metafields[w.key] || 0) > 0)

            if (warehouseHasStock) {
              html += '<div class="each_warehouse_block">'
              html +=
                '<span class="warehouse_name">' +
                w.name +
                '<br> <span class="warehouse_cat">' +
                t.warehouse +
                "</span></span>"
              html += '<ul class="warehouse_ul">'
              colorVariants.forEach((v) => {
                var stock = v.metafields[w.key] || 0
                if (stock > 0) {
                  html += '<li class="ai_store"><div class="desc-wrapper"><div class="input-box-price finv-btn">'
                  html +=
                    '<input size="3" type="number" class="quantity-input" name="quantity[' +
                    v.id +
                    ']" data-warehouse="' +
                    w.code +
                    '" value="" min="0" max="' +
                    stock +
                    '" onchange="imposeMinMax(this)">'
                  html +=
                    '<span class="normal_stock' + (stock < lowStockQty ? " less_stock" : "") + '">' + stock + "</span>"
                  html += "</div></div></li>"
                } else {
                  html += '<li class="ai_store"><div class="desc-wrapper"><div class="input-box-price finv-btn">'
                  html +=
                    '<input size="3" type="number" class="quantity-input_outstock" placeholder="' +
                    t.outOfStock +
                    '" disabled>'
                  html += '<span class="BIS_trigger out_stock" data-variant-id="' + v.id + '">Notify</span>'
                  html += "</div></div></li>"
                }
              })
              html += "</ul></div>"
            }
          })
        } else {
          html += '<div class="each_warehouse_block all_out_warehouse">' + t.allOutOfStock + "</div>"
        }

        html += "</div>"
      })

      html += "</div>"
      html +=
        '<button type="button" class="add-to-cart-bulk add_cart_bulk button--primary no_class" id="add-to-cart-bulk">' +
        t.addToCart +
        "</button>"
      html += "</form>"
      html += '<div class="warehouse_instruction">' + t.warehouse_instruction + "</div>"
      html += '<div class="warehouse-cutoff-title">' + t.cutoffTitle + "</div>"
      html += '<div class="warehouse-cutoff-time">' + t.cutoffTime + "</div>"
      html += '<div class="warehouse-cutoff-notice">' + t.cutoffNotice + "</div>"

      apiContainer.innerHTML = html
      initBulkFormEvents()
    }

    fetchVariants()
  }

  // Initialize form events (shared between Mode A and Mode B)
  function initBulkFormEvents() {
    var $ = window.jQuery
    if (!$) return

    $(".Color_warehouse_master_block").hide()
    var hasWhite = $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").length > 0
    var hasBlack = $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").length > 0
    var $preSelectedColorInput = $(".color-swatch input:checked")

    if ($preSelectedColorInput.length > 0) {
      var preSelectedColor = normalizeColor($preSelectedColorInput.closest(".color-swatch").data("color"))
      $(".Color_warehouse_master_block." + normalizeDotColor(preSelectedColor)).show()
    } else if (hasWhite) {
      $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").show()
    } else if (hasBlack) {
      $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").show()
    } else {
      $(".Color_warehouse_master_block").first().show()
    }

    var dropdownHeader = $(".dropdown-header")
    var dropdownOptions = $(".dropdownContentContainer")
    var arrow = $('<span class="arrow">&#9660;</span>')
    dropdownHeader.append(arrow)

    dropdownHeader.on("click", (event) => {
      dropdownOptions.toggle()
      arrow.html(dropdownOptions.is(":visible") ? "&#9650;" : "&#9660;")
      blinkCursor()
      event.stopPropagation()
    })

    $(".SelectOptions").on("click", function () {
      var selectedColorCircle = $(this).find(".color-circle").clone()
      var selectedColorText = $(this).text()
      arrow.html("&#9660;")
      dropdownHeader.empty().append(arrow, selectedColorCircle, selectedColorText)
      dropdownOptions.hide()
      $("#dropdownSearch").val("")
      $(".SelectOptions").show()

      var newSelectedColor = $(this).attr("value")
      $(".Color_warehouse_master_block").hide()
      $(".Color_warehouse_master_block." + normalizeDotColor(newSelectedColor)).show()
      
      // Try to find swatch by multiple methods
      var colorSwatchRadio = $(".color-swatch[data-color='" + newSelectedColor + "'] .color-swatch__radio")
      
      // Method 2: Match by background color/image (read from style attribute)
      if (!colorSwatchRadio.length) {
        var dropdownCircle = $(this).find(".color-circle")
        var dropdownStyleAttr = dropdownCircle.attr("style") || ""
        
        // Extract from dropdown
        var dropdownBgImageMatch = dropdownStyleAttr.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/i)
        var dropdownBgImageUrl = dropdownBgImageMatch ? dropdownBgImageMatch[1] : ""
        var dropdownBgColorMatch = dropdownStyleAttr.match(/background-color:\s*([^;]+)/i)
        var dropdownBgColor = dropdownBgColorMatch ? dropdownBgColorMatch[1].trim() : ""
        
        $(".color-swatch").each(function() {
          var swatchLabel = $(this).find("label")
          var swatchStyleAttr = swatchLabel.attr("style") || ""
          
          // Extract from swatch
          var swatchBgImageMatch = swatchStyleAttr.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/i)
          var swatchBgImageUrl = swatchBgImageMatch ? swatchBgImageMatch[1] : ""
          var swatchBgColorMatch = swatchStyleAttr.match(/background-color:\s*([^;]+)/i)
          var swatchBgColor = swatchBgColorMatch ? swatchBgColorMatch[1].trim() : ""
          
          var matchByImage = dropdownBgImageUrl && swatchBgImageUrl && dropdownBgImageUrl === swatchBgImageUrl
          var matchByColor = dropdownBgColor && swatchBgColor && dropdownBgColor === swatchBgColor
          
          if (matchByImage || matchByColor) {
            colorSwatchRadio = $(this).find(".color-swatch__radio")
            return false // break loop
          }
        })
      }
      
      if (colorSwatchRadio.length) colorSwatchRadio.click()
      $("#toggleView").text(t.viewAllColors)
      $("#add-to-cart-bulk-secondary").hide()
      selectedColor = newSelectedColor
    })

    $(document).on("click", (event) => {
      if (!$(event.target).closest(".dropdown-container").length) {
        dropdownOptions.hide()
        arrow.html("&#9660;")
      }
    })

    var searchInput = document.getElementById("dropdownSearch")
    if (searchInput) {
      searchInput.addEventListener("keyup", filterDropdown)
    }

    $("#toggleView").on("click", function () {
      var isViewAll = $(this).text() === t.viewAllColors
      if (isViewAll) {
        $(".Color_warehouse_master_block").show()
        $("#add-to-cart-bulk-secondary").show()
      } else {
        $(".Color_warehouse_master_block").hide()
        if (!selectedColor) {
          if (hasWhite) {
            $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").show()
          } else if (hasBlack) {
            $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").show()
          } else {
            $(".Color_warehouse_master_block").first().show()
          }
        } else {
          $(".Color_warehouse_master_block." + normalizeDotColor(selectedColor)).show()
        }
        $("#add-to-cart-bulk-secondary").hide()
      }
      $(this).text(isViewAll ? t.viewOneColor : t.viewAllColors)
    })

    $(".color-swatch").on("click", function () {
      var clickedColor = $(this).data("color") // This is normalized (no spaces)
      var clickedColorText = $(this).find('label').attr('title') || '' // Full color name with spaces
      var clickedColorDataValue = $(this).find('label').data('color-value') || clickedColorText // data-color-value attribute
      var selectedColorVal = normalizeColor(clickedColor)
      
      // Get swatch background style for matching - read from style attribute directly
      var swatchLabel = $(this).find('label')
      var swatchStyleAttr = swatchLabel.attr('style') || ''
      
      // Extract background-color from inline style
      var bgColorMatch = swatchStyleAttr.match(/background-color:\s*([^;]+)/i)
      var swatchBgColor = bgColorMatch ? bgColorMatch[1].trim() : ''
      
      // Extract background-image URL from inline style
      var bgImageMatch = swatchStyleAttr.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/i)
      var swatchBgImageUrl = bgImageMatch ? bgImageMatch[1] : ''
      
      // Try multiple methods to find the matching dropdown option
      var dropdownOption = null
      
      // Method 1: Direct value match (works when both are same language)
      dropdownOption = $('.SelectOptions[value="' + selectedColorVal + '"]')
      
      // Method 2: Match by data-translated-color attribute (normalized translated name)
      if (!dropdownOption.length) {
        dropdownOption = $('.SelectOptions[data-translated-color="' + selectedColorVal + '"]')
      }
      
      // Method 3: Match by data-original-color attribute (API stores English name here)
      if (!dropdownOption.length) {
        dropdownOption = $('.SelectOptions').filter(function() {
          var origColor = $(this).data('original-color') || ''
          return normalizeColor(origColor) === selectedColorVal
        })
      }
      
      // Method 4: Match by displayed text (dropdown shows translated name)
      if (!dropdownOption.length && clickedColorDataValue) {
        dropdownOption = $('.SelectOptions').filter(function() {
          var optionText = $(this).text().trim()
          return optionText === clickedColorDataValue
        })
      }
      
      // Method 5: Match by title attribute
      if (!dropdownOption.length && clickedColorText) {
        dropdownOption = $('.SelectOptions').filter(function() {
          var optionText = $(this).text().trim()
          return optionText === clickedColorText
        })
      }
      
      // Method 6: Match by background color or image (same in both languages)
      if (!dropdownOption.length && (swatchBgColor || swatchBgImageUrl)) {
        dropdownOption = $('.SelectOptions').filter(function() {
          var optionCircle = $(this).find('.color-circle')
          var optionStyleAttr = optionCircle.attr('style') || ''
          
          // Extract background-image URL from dropdown option
          var optionBgImageMatch = optionStyleAttr.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/i)
          var optionBgImageUrl = optionBgImageMatch ? optionBgImageMatch[1] : ''
          
          // Extract background-color from dropdown option
          var optionBgColorMatch = optionStyleAttr.match(/background-color:\s*([^;]+)/i)
          var optionBgColor = optionBgColorMatch ? optionBgColorMatch[1].trim() : ''
          
          // Match by background image URL if both have one
          if (swatchBgImageUrl && optionBgImageUrl && swatchBgImageUrl === optionBgImageUrl) {
            return true
          }
          // Match by background color if no image
          if (swatchBgColor && optionBgColor && swatchBgColor === optionBgColor) {
            return true
          }
          return false
        })
      }
      
      if (dropdownOption && dropdownOption.length) {
        var selectedColorCircle = dropdownOption.find(".color-circle").clone()
        var selectedColorText = dropdownOption.text()
        var actualColorVal = dropdownOption.attr("value")
        dropdownHeader.empty().append(arrow, selectedColorCircle, selectedColorText)
        $(".Color_warehouse_master_block").hide()
        $(".Color_warehouse_master_block." + normalizeDotColor(actualColorVal)).show()
        selectedColor = actualColorVal
      }
    })

    var addToCartBtn = document.getElementById("add-to-cart-bulk")
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", () => {
        var selectedVariants = []
        document.querySelectorAll(".quantity-input").forEach((input) => {
          var match = input.getAttribute("name").match(/\[(\d+)\]/)
          if (match) {
            var variantId = match[1]
            var quantity = Number.parseInt(input.value)
            var warehouse = input.getAttribute("data-warehouse")
            if (quantity > 0) {
              selectedVariants.push({ id: variantId, quantity: quantity, properties: { Warehouse: warehouse } })
            }
          }
        })

        document.dispatchEvent(new CustomEvent("theme:loading:start"))

        if (selectedVariants.length > 0) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            body: JSON.stringify({ items: selectedVariants }),
          })
            .then((response) => response.json())
            .then((data) => {
              document.documentElement.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: { selectedVariants: selectedVariants },
                }),
              )
            })
            .catch((error) => {
              console.error("Error:", error)
            })
        } else {
          alert("Please enter quantities for at least one item.")
        }
        document.querySelectorAll(".quantity-input").forEach((input) => {
          input.value = ""
        })
      })
    }
  }

  // Mode A: Liquid-based initialization
  function initModeALiquid() {
    var $ = window.jQuery
    if (!$) return

    $(".Color_warehouse_master_block").hide()
    var hasWhite = $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").length > 0
    var hasBlack = $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").length > 0
    var $preSelectedColorInput = $(".color-swatch input:checked")

    if ($preSelectedColorInput.length > 0) {
      var preSelectedColor = normalizeColor($preSelectedColorInput.closest(".color-swatch").data("color"))
      $(".Color_warehouse_master_block." + normalizeDotColor(preSelectedColor)).show()
    } else if (hasWhite) {
      $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").show()
    } else if (hasBlack) {
      $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").show()
    } else {
      $(".Color_warehouse_master_block").first().show()
    }

    $(".color-swatch").on("click", function () {
      var selectedColorVal = normalizeColor($(this).data("color"))
      var dropdownOption = $('.SelectOptions[value="' + selectedColorVal + '"]')
      var selectedColorCircle = dropdownOption.find(".color-circle").clone()
      var selectedColorText = dropdownOption.text()
      var dropdownHeader = $(".dropdown-header")
      var arrow = dropdownHeader.find(".arrow")
      if (!arrow.length) {
        arrow = $('<span class="arrow">&#9660;</span>')
      }
      dropdownHeader.empty().append(arrow, selectedColorCircle, selectedColorText)
      $(".Color_warehouse_master_block").hide()
      $(".Color_warehouse_master_block." + normalizeDotColor(selectedColorVal)).show()
      document
        .getElementById("colorDropdown")
        .dispatchEvent(new CustomEvent("colorChange", { bubbles: true, detail: { color: selectedColorVal } }))
    })

    var colorDropdown = document.getElementById("colorDropdown")
    if (colorDropdown) {
      colorDropdown.addEventListener("colorChange", (event) => {
        var newSelectedColor = event.detail.color
        $("#colorDropdown").val(newSelectedColor).trigger("change")
      })

      $(".color-swatch__radio").on("click", () => {
        $("#colorDropdown").addClass("dropdown-triggered")
      })

      colorDropdown.addEventListener("colorChange", (event) => {
        if (!event.target.classList.contains("dropdown-triggered")) {
          var newSelectedColor = event.detail.color
          if (newSelectedColor === t.viewAllColors) {
            $(".Color_warehouse_master_block").show()
            $("#toggleView").text(t.viewOneColor)
          } else {
            $(".Color_warehouse_master_block").hide()
            $(".Color_warehouse_master_block." + normalizeDotColor(newSelectedColor)).show()
            $(".color-swatch[data-color='" + newSelectedColor + "'] .color-swatch__radio").click()
            if (newSelectedColor !== selectedColor) {
              $("#toggleView").text(t.viewAllColors)
              $("#add-to-cart-bulk-secondary").hide()
            }
          }
          selectedColor = newSelectedColor
        } else {
          event.target.classList.remove("dropdown-triggered")
        }
      })

      colorDropdown.addEventListener("click", (event) => {
        if (event.target.classList.contains("SelectOptions")) {
          var newSelectedColor = event.target.getAttribute("value")
          if (newSelectedColor === t.viewAllColors) {
            document.querySelectorAll(".Color_warehouse_master_block").forEach((element) => {
              element.style.display = "block"
            })
            document.getElementById("toggleView").innerText = t.viewOneColor
          } else {
            document.querySelectorAll(".Color_warehouse_master_block").forEach((element) => {
              element.style.display = "none"
            })
            var colorDiv = document.querySelector(
              ".Color_warehouse_master_block." + normalizeDotColor(newSelectedColor),
            )
            if (colorDiv) {
              colorDiv.style.display = "block"
            }
            // Try to find swatch by multiple methods (for translation support)
            var colorSwatchRadio = document.querySelector(
              ".color-swatch[data-color='" + newSelectedColor + "'] .color-swatch__radio",
            )
            
            // Method 2: Try to find by matching background color/image (read style attribute directly)
            if (!colorSwatchRadio) {
              var dropdownOption = document.querySelector('.SelectOptions[value="' + newSelectedColor + '"]')
              if (dropdownOption) {
                var dropdownCircle = dropdownOption.querySelector(".color-circle")
                if (dropdownCircle) {
                  var dropdownStyleAttr = dropdownCircle.getAttribute("style") || ""
                  var dropdownBgImageMatch = dropdownStyleAttr.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/i)
                  var dropdownBgImageUrl = dropdownBgImageMatch ? dropdownBgImageMatch[1] : ""
                  var dropdownBgColorMatch = dropdownStyleAttr.match(/background-color:\s*([^;]+)/i)
                  var dropdownBgColor = dropdownBgColorMatch ? dropdownBgColorMatch[1].trim() : ""
                  
                  document.querySelectorAll(".color-swatch").forEach(function(swatch) {
                    if (colorSwatchRadio) return
                    var swatchLabel = swatch.querySelector("label")
                    if (swatchLabel) {
                      var swatchStyleAttr = swatchLabel.getAttribute("style") || ""
                      var swatchBgImageMatch = swatchStyleAttr.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/i)
                      var swatchBgImageUrl = swatchBgImageMatch ? swatchBgImageMatch[1] : ""
                      var swatchBgColorMatch = swatchStyleAttr.match(/background-color:\s*([^;]+)/i)
                      var swatchBgColor = swatchBgColorMatch ? swatchBgColorMatch[1].trim() : ""
                      
                      var matchByImage = dropdownBgImageUrl && swatchBgImageUrl && dropdownBgImageUrl === swatchBgImageUrl
                      var matchByColor = dropdownBgColor && swatchBgColor && dropdownBgColor === swatchBgColor
                      
                      if (matchByImage || matchByColor) {
                        colorSwatchRadio = swatch.querySelector(".color-swatch__radio")
                      }
                    }
                  })
                }
              }
            }
            
            if (colorSwatchRadio) {
              colorSwatchRadio.click()
            }
            if (newSelectedColor !== selectedColor) {
              document.getElementById("toggleView").innerText = t.viewAllColors
              document.getElementById("add-to-cart-bulk-secondary").style.display = "none"
            }
          }
          selectedColor = newSelectedColor
        }
      })
    }

    var dropdownHeader = $(".dropdown-header")
    var dropdownOptions = $(".dropdownContentContainer")
    var arrow = $('<span class="arrow">&#9660;</span>')
    dropdownHeader.append(arrow)

    dropdownHeader.on("click", (event) => {
      dropdownOptions.toggle()
      arrow.html(dropdownOptions.is(":visible") ? "&#9650;" : "&#9660;")
      blinkCursor()
      event.stopPropagation()
    })

    $(".SelectOptions").on("click", function () {
      var selectedColorCircle = $(this).find(".color-circle").clone()
      var selectedColorText = $(this).text()
      arrow.html("&#9660;")
      dropdownHeader.empty().append(arrow, selectedColorCircle, selectedColorText)
      dropdownOptions.hide()
      $("#dropdownSearch").val("")
      $(".SelectOptions").show()
    })

    $(document).on("click", (event) => {
      if (!$(event.target).closest(".dropdown-container").length) {
        dropdownOptions.hide()
        arrow.html("&#9660;")
      }
    })

    var searchInput = document.getElementById("dropdownSearch")
    if (searchInput) {
      searchInput.addEventListener("keyup", filterDropdown)
    }

    $("#toggleView").on("click", function () {
      var isViewAll = $(this).text() === t.viewAllColors
      if (isViewAll) {
        $(".Color_warehouse_master_block").show()
        $("#add-to-cart-bulk-secondary").show()
      } else {
        $(".Color_warehouse_master_block").hide()
        if (!selectedColor) {
          var hasWhiteToggle = $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").length > 0
          var hasBlackToggle = $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").length > 0
          if (hasWhiteToggle) {
            $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").show()
          } else if (hasBlackToggle) {
            $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").show()
          } else {
            $(".Color_warehouse_master_block").first().show()
          }
        } else {
          $(".Color_warehouse_master_block." + normalizeDotColor(selectedColor)).show()
        }
        $("#add-to-cart-bulk-secondary").hide()
      }
      $(this).text(isViewAll ? t.viewOneColor : t.viewAllColors)
    })

    // Add to cart for Mode A
    var addToCartBtn = document.getElementById("add-to-cart-bulk")
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", () => {
        var selectedVariants = []
        document.querySelectorAll(".quantity-input").forEach((input) => {
          var match = input.getAttribute("name").match(/\[(\d+)\]/)
          if (match) {
            var variantId = match[1]
            var quantity = Number.parseInt(input.value)
            var warehouse = input.getAttribute("data-warehouse")
            if (quantity > 0) {
              selectedVariants.push({ id: variantId, quantity: quantity, properties: { Warehouse: warehouse } })
            }
          }
        })

        document.dispatchEvent(new CustomEvent("theme:loading:start"))

        if (selectedVariants.length > 0) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            body: JSON.stringify({ items: selectedVariants }),
          })
            .then((response) => response.json())
            .then((data) => {
              document.documentElement.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: { selectedVariants: selectedVariants },
                }),
              )
            })
            .catch((error) => {
              console.error("Error:", error)
            })
        } else {
          alert("Please enter quantities for at least one item.")
        }
        document.querySelectorAll(".quantity-input").forEach((input) => {
          input.value = ""
        })
      })
    }
  }

  // Main initialization
  document.addEventListener("DOMContentLoaded", () => {
    var apiContainer = document.getElementById("bulk-order-api-container")

    if (apiContainer) {
      // Mode B: Use Storefront API
      initModeBAPI()
    } else {
      // Mode A: Use Liquid-rendered form
      initModeALiquid()
    }
  })
})()
